import PropTypes from 'prop-types';
import React from 'react';
import './input.scss';

/**
 * Universal input that supports theme-based and font-size-based styling.
 * - Supports variants like "email"
 * - Automatically renders a label if provided
 */
const AppInput = React.forwardRef(
   ({ className = '', label = '', variant = '', id, required = false, type, placeholder, ...rest }, ref) => {
      const isEmail = variant === 'email';
      let inputType = type;
      if (type !== 'textarea') {
         inputType = type || (isEmail ? 'email' : 'text');
      }
      const inputPlaceholder = placeholder || (isEmail ? 'Enter your email' : '');

      const Component = type === 'textarea' ? 'textarea' : 'input';

      const inputElement = (
         <Component
            id={id}
            ref={ref}
            type={inputType}
            placeholder={inputPlaceholder}
            required={required}
            className={`app-input  ${className}`}
            {...rest}
         />
      );

      if (label || variant) {
         const groupClass = ['app-input-group', 'feedback-input', 'ct-flex', 'ct-fcol'];
         if (variant) groupClass.push(`variant-${variant}`);

         return (
            <div className={groupClass.join(' ')}>
               {label && (
                  <label htmlFor={id} className="app-input-label">
                     {label}
                     {required && <span className="required-mark">*</span>}
                  </label>
               )}
               {inputElement}
            </div>
         );
      }

      return inputElement;
   },
);

AppInput.displayName = 'AppInput';

AppInput.propTypes = {
   className: PropTypes.string,
   label: PropTypes.string,
   variant: PropTypes.string,
   id: PropTypes.string,
   required: PropTypes.bool,
   type: PropTypes.string,
   placeholder: PropTypes.string,
};

export default AppInput;
